/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.standards.course-codes'},
});

const CourseCodesItem = () => (
  <RouteLinkItem
    route="midas/settings/standards/course-codes"
    title={messages.title}
  />
);

export default CourseCodesItem;
